import Mooring from './Mooring';
export default class MooringAfterArrival extends Mooring {
    type;
    constructor(port, type, freeText) {
        super(port, freeText);
        this.type = type;
    }
}
//# sourceMappingURL=MooringAfterArrival.js.map